import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import BookablePackageRate from '../models/BookablePackageRate';
import Urls from './../api/Urls';

export function getBookablePackageRateList(hotelId, data) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.BOOKABLE_PACKAGE_RATE_LIST,
        endpointParams: { hotelId },
        parser: data => bookablePackageRatesDataParser(data, hotelId),
        params: data,
    }).get();
}

export function syncBookablePackageRatesAll(hotelId) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.BOOKABLE_PACKAGE_RATE_SYNC_ALL,
        endpointParams: { hotelId },
    }).get();
}

export function syncBookablePackageRate(id) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.BOOKABLE_PACKAGE_RATE_SYNC,
        endpointParams: { id },
    }).get();
}

export function getBookablePackageRateDetail(id) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.BOOKABLE_PACKAGE_RATE_DETAIL,
        endpointParams: { id },
        parser: data => {
            return new BookablePackageRate({ ...data, hotelId: id })
        },
    }).get();
}

export function updateBookablePackageRate(data, id){
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.BOOKABLE_PACKAGE_RATE_UPDATE,
        endpointParams: { id },
    }).put(data);
}

export function sortBookablePackageRate(data){
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.BOOKABLE_PACKAGE_RATE_SORT,
    }).put(data);
}

export function getAllBookablePackageRateList(hotelId) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.BOOKABLE_PACKAGE_RATE_ALL_LIST,
        endpointParams: { hotelId },
        parser: (data, hotelId) => {
            return {bookablePackageRates: (data?.bookablePackageRates || []).map(item => new BookablePackageRate({ ...item, hotelId }))}
        },
    }).get();
}

const bookablePackageRatesDataParser = (data, hotelId) => ({
    data: (data || []).map(item => new BookablePackageRate({ ...item, hotelId }))
})